import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/atc/ATC CREAM MILK.png";
import BiscuitImg from "../../../assets/products/atc/ATC-Milk.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 125,
  },
  {
    grams: 150,
  },
];

export default function MilkATCProduct() {
  return (
    <>
      <Helmet>
        <title>
          ATC Milk Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz ATC Milk Cream Biscuits — creamy, milky-flavored ATC cream biscuits tailored for quality and taste. View pack sizes and global specs."
        />
        <meta
          name="keywords"
          content="ATC Milk Cream Biscuit, BearBitz ATC Milk"
        />
        <link rel="canonical" href="https://www.bearbitz.in/atc/milk" />
        <meta property="og:title" content="ATC Milk Cream Biscuit – BearBitz" />
        <meta
          property="og:description"
          content="Rich milky-flavored cream biscuit in ATC format with export-ready packaging and premium quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="MILK"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in The rich taste of ATC Cream Biscuits, where every crunchy bite meets a smooth and creamy filling."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#057EF8"
        sectionBgColor="#E3F1FF"
        productBgcolor="#AAD6FF"
        tableheadBgcolor="#057EF8"
        tableBgcolor="#EDF6FF"
        footerBgcolor="#057EF8"
      />
    </>
  );
}
